import React from 'react';
import { useCoinsGame } from './useCoinsGame';
import { CoinItem } from './CoinItem';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

export const CoinsGame = () => {
  const { 
    coins, 
    score, 
    timeLeft, 
    gameStarted, 
    isGameOver,
    cerebrixEarned,
    startGame, 
    collectCoin 
  } = useCoinsGame();

  return (
    <Card className="w-full max-w-4xl mx-auto p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <Button 
          variant="ghost" 
          onClick={() => window.history.back()}
          className="text-sm"
        >
          ← Volver a Juegos
        </Button>
        <h2 className="text-xl md:text-2xl font-bold">Recolector de Premios</h2>
      </div>

      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-2">
          <span role="img" aria-label="trophy">🏆</span>
          <span className="font-semibold">Puntos: {score}</span>
        </div>
        <div className="flex items-center gap-2">
          <span role="img" aria-label="clock">⏱️</span>
          <span className="font-semibold">Tiempo: {timeLeft}s</span>
        </div>
      </div>

      {!gameStarted && !isGameOver && (
        <div className="text-center py-8">
          <p className="mb-4 text-gray-600">
            ¡Recolecta todos los premios antes de que se acabe el tiempo! 
            Cada premio tiene un valor diferente:
          </p>
          <div className="flex justify-center gap-4 mb-4 flex-wrap">
            <span title="Bronce">🥉 5 pts</span>
            <span title="Plata">🥈 10 pts</span>
            <span title="Oro">🥇 20 pts</span>
            <span title="Gema">💎 40 pts</span>
            <span title="Trofeo">🏆 80 pts</span>
          </div>
          <p className="mb-4 text-sm text-gray-500">
            Ganarás 1 Cerebrix por cada 100 puntos acumulados.
            ¡El tiempo restante te dará puntos extra!
          </p>
          <Button onClick={startGame}>Comenzar Juego</Button>
        </div>
      )}

      {(gameStarted || isGameOver) && (
        <div 
          className="game-container relative bg-gray-100 rounded-lg w-full overflow-hidden"
          style={{ 
            height: 'min(60vh, 400px)',
            minHeight: '300px'
          }}
        >
          {coins.map(coin => (
            <CoinItem
              key={coin.id}
              coin={coin}
              onCollect={() => collectCoin(coin)}
            />
          ))}
          {isGameOver && (
            <div className="absolute inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center">
              <div className="bg-white p-6 rounded-lg text-center max-w-sm mx-4">
                <h3 className="text-xl font-bold mb-2">¡Juego Terminado!</h3>
                <p className="mb-2">Puntuación Final: {score}</p>
                <div className="mb-4">
                  <p className="text-lg font-bold text-primary">
                    ¡Has ganado {cerebrixEarned} Cerebrix! 🧠
                  </p>
                </div>
                <Button onClick={startGame}>Jugar de Nuevo</Button>
              </div>
            </div>
          )}
        </div>
      )}
    </Card>
  );
};
